import styles from "./Button.module.scss";
import cn from "classnames";
import { ButtonPropsI } from "./Button.props";
import Loader from "@components/global/Loader/Loader";
import { useRef } from "react";

export default function Button({
  className,
  children,
  type,
  white,
  grey,
  red,
  active,
  disabled,
  loading,

  onClick,
  ...props
}: ButtonPropsI) {
  const ref = useRef<HTMLButtonElement>(null);
  const onClickBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(e);
    ref.current?.classList.add(styles.click);
    setTimeout(() => ref.current?.classList.remove(styles.click), 50);
  };
  return (
    <button
      ref={props.buttonRef}
      className={cn(styles.primary, className, {
        [styles.white]: white,
        [styles.grey]: grey,
        [styles.red]: red,
        [styles.active]: active,
        [styles.disabled]: disabled || loading,
      })}
      type={type}
      disabled={disabled || loading}
      onClick={onClickBtn}
      {...props}
    >
      {loading ? (
        <div className={styles.loaderWrapper}>
          <Loader size={18} className={styles.loader} />
        </div>
      ) : (
        children
      )}
    </button>
  );
}
